import React from "react";
import { Heart } from "lucide-react";

// ASA brand mark: shield + heart (protection + care) in calming teal
export default function AsaLogo({ light = false, size = 34 }) {
  const color = light ? "#ffffff" : "#0d9488";
  const accent = light ? "#ffffff" : "#0f766e";
  return (
    <div className="flex items-center gap-2 select-none">
      <div
        className="rounded-xl flex items-center justify-center"
        style={{ width: size, height: size, backgroundColor: light ? "rgba(255,255,255,0.18)" : "#e6f4f2" }}
      >
        <Heart size={size * 0.55} style={{ color }} fill={light ? "rgba(255,255,255,0.9)" : "#0d9488"} />
      </div>
      <div className="leading-none">
        <span className="font-head font-bold tracking-tight block" style={{ color, fontSize: size * 0.5 }}>
          ASAL
        </span>
        <span className="font-medium block" style={{ color: accent, fontSize: size * 0.3, opacity: 0.8 }}>
          Autoimmune Symptoms, Awareness &amp; Learning
        </span>
      </div>
    </div>
  );
}
